module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "miners-container"
  }, _vm._l((_vm.filteredMiners), function(o) {
    return _c('div', {
      staticClass: "miner"
    }, [_c('div', {
      staticClass: "title-container"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('div', {
      staticClass: "title is-6"
    }, [_vm._v(_vm._s(o.name))]), _c('div', {
      staticClass: "subtitle is-6 mt-0"
    }, [_vm._v(_vm._s(o.description))])])]), _c('div', {
      staticClass: "pl-2"
    }, [_c('div', {
      staticClass: "tabs is-small is-boxed os-tabs"
    }, [_c('ul', [_c('li', {
      class: {
        'is-active': o.osSelected === 'windows'
      },
      on: {
        "click": function($event) {
          o.osSelected = 'windows'
        }
      }
    }, [_vm._m(3, true)]), _c('li', {
      class: {
        'is-active': o.osSelected === 'linux'
      },
      on: {
        "click": function($event) {
          o.osSelected = 'linux'
        }
      }
    }, [_vm._m(4, true)])])]), _c('div', {
      staticClass: "command"
    }, [_c('pre', [_c('span', [_vm._v(_vm._s(_vm.fullComand(o)))])]), _c('button', {
      staticClass: "button right",
      on: {
        "click": function($event) {
          _vm.copyToClipboard(_vm.fullComand(o))
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard"
    }), _c('span', [_vm._v("Copy")])])]), _c('div', {
      staticClass: "button-down-container"
    }, [_c('a', {
      staticClass: "button button-down is-info",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.downloadBatFile(o, _vm.fullComand(o))
        }
      }
    }, [_c('span', {
      staticClass: "mr-5"
    }, [_vm._v("Download ")]), _c('span', {
      staticClass: "mr-5"
    }, [_vm._v("." + _vm._s(o[o.osSelected + 'DownloadFileExtension']) + " ")]), _c('span', [_vm._v("file")]), _c('i', {
      staticClass: "fa fa-download"
    })]), _c('a', {
      staticClass: "button button-down button-default",
      attrs: {
        "href": o.urlDocumentation,
        "target": "_blank"
      }
    }, [_c('span', [_vm._v("Official documentation")]), _c('i', {
      staticClass: "fa fa-external-link"
    })]), _c('a', {
      staticClass: "button button-down button-default",
      attrs: {
        "href": o.urlDownload,
        "target": "_blank"
      }
    }, [_c('span', [_vm._v("Download miner files")]), _c('i', {
      staticClass: "fa fa-external-link"
    })])]), _c('div', {
      staticClass: "subtitle is-7 mt-10 has-text-centered"
    }, [_c('div', {
      staticClass: "mb-5"
    }, [_c('span', [_vm._v("Be sure to check our support article for more details on ")]), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": o.urlSupportArticle,
        "target": "_blank"
      }
    }, [_vm._v("how to configure " + _vm._s(o.name) + ".")])]), _vm._m(5, true), _vm._m(6, true)])])])
  }), 0), _c('hr'), _vm._m(7), _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('p', {
    staticClass: "mr-5"
  }, [_vm._v("After you start mining (5 minutes aproximately), you will be able to see your stats on the website, along with your current balance, past payouts and more:")]), _c('div', {
    staticClass: "is-flex jcc aic mt-20"
  }, [_c('div', {
    staticClass: "button-stats-container"
  }, [_c('a', {
    staticClass: "button button-stats is-info",
    attrs: {
      "href": '/address/' + _vm.address + '?coin=' + _vm.coin.symbol,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "mr-5"
  }, [_vm._v("See your stats")]), _c('i', {
    staticClass: "fa fa-line-chart"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Start mining!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica step-explanation"
  }, [_c('span', [_vm._v("You have finished!, you can now start mining, simply download the auto-generated .bat / .sh file and run it inside your miner files directory (depending on the miner you choose).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-windows"
  })]), _c('span', [_vm._v("Windows")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-linux"
  })]), _c('span', [_vm._v("Linux")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("Learn how to fix the restrictions ")]), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "/support/article/how-to-execute-our-downloadable-bat-file",
      "target": "_blank"
    }
  }, [_vm._v("when downloading or running a bat file on Windows.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('span', [_vm._v("Learn how to ")]), _c('a', {
    staticClass: "info-link",
    attrs: {
      "href": "/support/article/how-to-create-a-bat-file",
      "target": "_blank"
    }
  }, [_vm._v("create a .bat (batch) file")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Let the monitoring begins")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f48deb0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_final.vue
// module id = 364
// module chunks = 1